function r() {
  return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function(n) {
    const x = Math.random() * 16 | 0;
    return (n === "x" ? x : x & 3 | 8).toString(16);
  });
}
export {
  r as guid
};
